import { render, staticRenderFns } from "./PhysicianDuplicateGroup.vue?vue&type=template&id=30e39d79&scoped=true"
import script from "./PhysicianDuplicateGroup.vue?vue&type=script&lang=js"
export * from "./PhysicianDuplicateGroup.vue?vue&type=script&lang=js"
import style0 from "./PhysicianDuplicateGroup.vue?vue&type=style&index=0&id=30e39d79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e39d79",
  null
  
)

export default component.exports